"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allSiteConfig = void 0;
/**
 * Query for all `siteConfig`
 *
 * @returns {object} Contentful query
 */
// eslint-disable-next-line import/prefer-default-export
var allSiteConfig = function allSiteConfig() {
  return {
    content_type: 'siteConfig'
  };
};
exports.allSiteConfig = allSiteConfig;